/**
 * Утилита для хранения токена доступа в localStorage
 * Работает только для development и staging окружений
 * В production токен хранится только в памяти (Redux store)
 */

const TOKEN_STORAGE_KEY = 'auth_token';

/**
 * Проверяет, следует ли использовать localStorage для хранения токена
 * @returns true для dev и staging, false для production
 */
const shouldUseLocalStorage = (): boolean => {
  // Development режим (npm run dev)
  if (import.meta.env.DEV) {
    return true;
  }

  // Staging окружение (production build с VITE_SENTRY_ENV=staging)
  if (import.meta.env.VITE_SENTRY_ENV === 'staging') {
    return true;
  }

  // Production окружение - не используем localStorage
  return false;
};

/**
 * Сохраняет токен в localStorage (только для dev/staging)
 * @param token - JWT токен доступа
 */
export const saveToken = (token: string): void => {
  if (!shouldUseLocalStorage()) {
    return;
  }

  try {
    localStorage.setItem(TOKEN_STORAGE_KEY, token);
  } catch (error) {
    console.error('Failed to save token to localStorage:', error);
  }
};

/**
 * Загружает токен из localStorage
 * @returns токен или null, если не найден или localStorage недоступен
 */
export const loadToken = (): string | null => {
  if (!shouldUseLocalStorage()) {
    return null;
  }

  try {
    return localStorage.getItem(TOKEN_STORAGE_KEY);
  } catch (error) {
    console.error('Failed to load token from localStorage:', error);
    return null;
  }
};

/**
 * Удаляет токен из localStorage
 */
export const clearToken = (): void => {
  if (!shouldUseLocalStorage()) {
    return;
  }

  try {
    localStorage.removeItem(TOKEN_STORAGE_KEY);
  } catch (error) {
    console.error('Failed to clear token from localStorage:', error);
  }
};
